const { destinationBankAccountStatus } = require('@transfeeradev/api-enums');
const PersonTypeService = require('../PersonTypeService');
const TransferPixService = require('../TransferPixService');

class DestinationBankAccount {
  /**
   * @returns {Dba}
   */
  static format(dba, { shouldRemoveFields = true, piiObfuscationEnabled = true } = {}) {
    if (dba) {
      if (dba.dataValues) {
        dba = dba.dataValues;
      }

      if (dba.status === destinationBankAccountStatus.DRAFT) {
        dba.status = destinationBankAccountStatus.CREATED;
      }

      const isPixDba = TransferPixService.isPix(dba);

      return isPixDba
        ? formatPixDba(dba, { shouldRemoveFields, piiObfuscationEnabled })
        : formatStandardDba(dba, { shouldRemoveFields, piiObfuscationEnabled });
    }

    return dba;
  }
}

function removeFields(dba, fieldsToRemove) {
  fieldsToRemove.forEach(f => delete dba[f]);
}

/**
 * @returns {DbaPix|DbaFull}
 */
function formatPixDba(dba, { shouldRemoveFields, piiObfuscationEnabled }) {
  if (piiObfuscationEnabled) {
    dba.cpf_cnpj = PersonTypeService.obfuscateCPF(dba.cpf_cnpj);
  }

  if (shouldRemoveFields && piiObfuscationEnabled) {
    removeFields(dba, ['account', 'account_digit', 'agency', 'agency_digit', 'account_type', 'bank_id', 'Bank']);
  }

  return dba;
}

/**
 * @returns {DbaStd|DbaFull}
 */
function formatStandardDba(dba, { shouldRemoveFields }) {
  if (shouldRemoveFields) {
    removeFields(dba, ['pix_key_type', 'pix_key']);
  }

  return dba;
}

module.exports = DestinationBankAccount;
